// //---------------------
// // 셜록
// //---------------------
import store from "@/store";
import { fnIsSherlockSubscriptionEnabled } from "@/components/sherlock/sherlockSubscriptionAccessHelpers.js";

// NZSC-3086 1차 prod 게이트: 비테스터가 URL 직접 진입해도 구독 페이지 못 보게 차단.
// 로그인은 살아있어야 하므로 통과시키고 /sherlock/dashboard 로 redirect (랜딩 X — 로그인 상태에서 어색).
function fnSubscriptionRouteGuard(to, from, next) {
  if (!localStorage.naezip_to_ac_se) {
    next("/sherlock");
    return;
  }
  const isTester = store.getters["userStore/isInternalTester"];
  if (!fnIsSherlockSubscriptionEnabled(isTester)) {
    next("/sherlock/dashboard");
    return;
  }
  next();
}

// NZSC-4281: 대시보드 화면들과 같은 로그인 가드(토큰 없으면 /sherlock).
function fnRequireSherlockLogin(to, from, next) {
  if (localStorage.naezip_to_ac_se) {
    next();
  } else {
    next("/sherlock");
  }
}

const sherlockRouter = [
  {
    path: "/sherlock",
    component: () => import("../components/sherlock/SherlockLayout.vue"),
    children: [
      {
        path: "/sherlock/entry",
        name: "sherlock-entry",
        component: () => import("../views/sherlock/EntryView.vue"),
      },
      {
        path: "/sherlock/login",
        name: "sherlock-login",
        component: () => import("../views/sherlock/LoginView.vue"),
      },

      // 아이디/비밀번호 로그인
      {
        path: "/sherlock/auth/login",
        name: "sherlock-auth-login",
        component: () => import("../views/sherlock/auth/SherlockAuthLoginView.vue"),
      },

      // 회원가입
      {
        path: "/sherlock/register",
        name: "sherlock-register",
        component: () => import("../views/sherlock/auth/SherlockAuthRegisterView.vue"),
      },

      // 아이디 찾기
      {
        path: "/sherlock/find-id",
        name: "sherlock-find-id",
        component: () => import("../views/sherlock/auth/SherlockAuthFindIdView.vue"),
      },

      // 비밀번호 재설정
      {
        path: "/sherlock/reset-password",
        name: "sherlock-reset-password",
        component: () => import("../views/sherlock/auth/SherlockAuthResetPasswordView.vue"),
      },
      {
        path: "/sherlock/landing",
        name: "sherlock-landing",
        component: () => import("../views/sherlock/LandingView.vue"),
        // NZSC-3236: 랜딩 자체 공용 네비(SherlockLandingNav, 로고+3메뉴+로그인)를 렌더하므로
        // 셜록 회원 헤더(SherlockHeader)는 숨겨 헤더 중복을 막는다. 로그인 버튼은 공용 네비가 대체.
        meta: { hideSherlockHeader: true },
      },
      // NZSC-3236 영업용 견적받기 랜딩 (게스트 접근, 로그인 불필요).
      // 자체 견적 CTA/업로드/팝업 흐름. 셜록 회원 헤더는 숨김(자체 네비 포함 랜딩).
      {
        path: "/sherlock/quote",
        name: "sherlock-quote",
        component: () => import("../views/sherlock/quote/QuoteLandingView.vue"),
        meta: { hideSherlockHeader: true },
      },
      // NZSC-3050 / NZSC-3086: 무료체험 정책 폐지. 옛 무료체험 LP 진입점들은 메인 랜딩으로 흡수.
      // 1차 prod 배포 시 비테스터가 SubscriptionInfo 게이트로 튕기는 회귀 차단 — 광고/SEO 트래픽은
      // /sherlock/landing (LandingView) 메인 LP 로 회수. 테스터/비테스터 무관 동일 동작.
      {
        path: "/sherlock/welcome",
        name: "sherlock-landing-freetrial",
        redirect: "/sherlock/landing",
      },
      {
        path: "/sherlock/landing/freetrial",
        redirect: "/sherlock/landing",
      },
      {
        path: "/sherlock/dashboard",
        name: "sherlock-dashboard",
        component: () => import("../views/sherlock/DashBoardView.vue"),
      },

      // 메인 - 포인트 화면.
      {
        path: "/sherlock/dashboard/point",
        name: "sherlock-dashboard-point",
        component: () => import("../views/sherlock/dashboard/PointView.vue"),
        beforeEnter: (to, from, next) => {
          if (!localStorage.naezip_to_ac_se) {
            next("/sherlock");
            return;
          }
          // NZSC-3047 풀오픈: 포인트 재충전 전면 불가 (재결제는 구독 요금제로만).
          // 모든 충전 결제 진입(사이드바/헤더/조회흐름 모달 '충전하기')이 ?tab=payment 로 수렴 →
          // 본 라우트 가드가 단일 차단점. payment 탭 진입 시 구독 요금제 화면으로 유도.
          if (to.query.tab === "payment") {
            next("/sherlock/subscription");
            return;
          }
          next();
        },
      },

      // 메인 - 다주택 조회 화면.
      {
        path: "/sherlock/dashboard/search",
        name: "sherlock-dashboard-search",
        component: () => import("../views/sherlock/dashboard/SearchView.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },

      // 메인 - 등기부등본 발급 화면.
      {
        path: "/sherlock/dashboard/document",
        name: "sherlock-dashboard-document",
        component: () => import("../views/sherlock/dashboard/DocumentView.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },

      // 메인 - 조회/발급 내역 화면.
      {
        path: "/sherlock/dashboard/inquiry",
        name: "sherlock-dashboard-inquiry",
        component: () => import("../views/sherlock/dashboard/InquiryView.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },

      //조회결과
      {
        path: "/sherlock/inquiry/result/:ownerPropertyQuerySeq",
        name: "sherlock-inquiry-result",
        component: () => import("../views/sherlock/inquiry/SearchResultView.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },
      {
        path: "/sherlock/inquiry/danger/:ownerPropertyQuerySeq",
        name: "sherlock-inquiry-danger",
        component: () => import("../views/sherlock/inquiry/DangerView.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },

      // 메인 - 체납∙연체 조회 화면.
      {
        path: "/sherlock/dashboard/delinquency",
        name: "sherlock-dashboard-delinquency",
        component: () => import("../views/sherlock/dashboard/DelinquencyView.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },

      // NZSC-3054 — 리포트 샘플 미리보기 (28391 CTA → 새 탭). 가짜 데이터 결과 화면.
      {
        path: "/sherlock/dashboard/delinquency/sample",
        name: "sherlock-dashboard-delinquency-sample",
        component: () =>
          import("../views/sherlock/credit-default/SherlockDelinquencySamplePreviewView.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },

      // NZSC-3076 — 체납∙연체 이력 row 클릭 결과 페이지 (요청자 재진입, 무제한 영구 접근).
      // BE NZSC-3075: GET /v1/sherlock/credit/:seq (AuthSherlockGuard).
      // 권한/만료 실패 시 wrapper 가 이력 탭으로 redirect (디자이너 안내 카피 시안 대기).
      {
        path: "/sherlock/dashboard/delinquency/result/:seq",
        name: "sherlock-dashboard-delinquency-result",
        component: () =>
          import("../views/sherlock/credit-default/SherlockDelinquencyResultPage.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },

      // 메인 - 서비스 의견 남기기 화면.
      {
        path: "/sherlock/dashboard/opinion",
        name: "sherlock-dashboard-opinion",
        component: () => import("../views/sherlock/SherlockOpinionView.vue"),
        beforeEnter: (to, from, next) => {
          if (localStorage.naezip_to_ac_se) {
            next();
          } else {
            next("/sherlock");
          }
        },
      },

      // NZSC-3047/3050: 구독 정보 (1·2·3번 세그먼트 분기는 컴포넌트 내부에서)
      // NZSC-3086: beforeEnter 에 1차 prod 테스터 게이트 적용 (fnSubscriptionRouteGuard).
      {
        path: "/sherlock/subscription",
        name: "sherlock-subscription-info",
        component: () => import("../views/sherlock/subscription/SubscriptionInfo.vue"),
        beforeEnter: fnSubscriptionRouteGuard,
      },

      // NZSC-3086: 옛 경로 `/sherlock/dashboard/subscription` 가 코드 8군데서 router.push 됨.
      // 별도 페이지로 두지 않고 동일 SubscriptionInfo 로 매핑 + 같은 게이트 적용.
      // (라우트 미정의로 navigation fail 나던 잠재 버그 + 비테스터 노출 동시 해결)
      {
        path: "/sherlock/dashboard/subscription",
        name: "sherlock-dashboard-subscription-legacy",
        component: () => import("../views/sherlock/subscription/SubscriptionInfo.vue"),
        beforeEnter: fnSubscriptionRouteGuard,
      },

      // NZSC-3102 hotfix: 12+ 군데에서 `/sherlock/dashboard/subscription`로 push하는데
      // 실제 라우트는 `/sherlock/subscription` — alias 대신 redirect로 안전하게 흡수.
      {
        path: "/sherlock/dashboard/subscription",
        redirect: "/sherlock/subscription",
      },

      // NZSC-3047: 엔터프라이즈 요금제 문의하기 (Figma 11856-8394 / 11857-8815 / 11857-9314).
      // 제출 시 슬랙 incoming webhook 으로 전송 (FE 직통).
      {
        path: "/sherlock/subscription/enterprise-inquiry",
        name: "sherlock-subscription-enterprise-inquiry",
        component: () => import("../views/sherlock/subscription/EnterpriseInquiryView.vue"),
        beforeEnter: fnSubscriptionRouteGuard,
      },

      // NZSC-4281 담보물 관리 — 등기변동 모니터링.
      // 메뉴 진입점. GET /v1/sherlock/monitoring/contract 로 분기: NONE → 소개 랜딩, ACTIVE/ENDED → 모니터링 화면.
      {
        path: "/sherlock/monitoring",
        name: "sherlock-monitoring",
        component: () => import("../views/sherlock/monitoring/MonitoringEntryView.vue"),
        beforeEnter: fnRequireSherlockLogin,
      },
      // 소개 랜딩 (미계약 유저 진입, 구독 정보 '소개 보기')
      {
        path: "/sherlock/monitoring/intro",
        name: "sherlock-monitoring-intro",
        component: () => import("../views/sherlock/monitoring/MonitoringIntroView.vue"),
        beforeEnter: fnRequireSherlockLogin,
      },
      // 문의하기 (?module=regular|oneoff — 관심 종류 기본 선택)
      {
        path: "/sherlock/monitoring/inquiry",
        name: "sherlock-monitoring-inquiry",
        component: () => import("../views/sherlock/monitoring/MonitoringInquiryView.vue"),
        beforeEnter: fnRequireSherlockLogin,
      },
      // 미리보기 (예시 데이터 — 모니터링 화면 preview 모드, C-2 에서 채움)
      {
        path: "/sherlock/monitoring/preview",
        name: "sherlock-monitoring-preview",
        component: () => import("../views/sherlock/monitoring/MonitoringPreviewView.vue"),
        beforeEnter: fnRequireSherlockLogin,
      },

      // NZSC-3047/3050: 구독 사용내역
      {
        path: "/sherlock/subscription/usage",
        name: "sherlock-subscription-usage",
        component: () => import("../views/sherlock/subscription/UsageHistory.vue"),
        beforeEnter: fnSubscriptionRouteGuard,
      },
    ],
  },
  //로그인
  {
    path: "/sherlock/login/complete",
    name: "sherlock-login-complete",
    component: () => import("../views/sherlock/user/LoginCompleteView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se || to.query.code) {
        next();
      } else {
        next("/sherlock");
      }
    },
  },

  //포인트
  {
    path: "/sherlock/payment/complete",
    name: "sherlock-payment-complete",
    component: () => import("../views/sherlock/payment/CompleteView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/sherlock");
      }
    },
  },

  // NZSC-3054 셜록 체납∙연체 — 개인 동의 외부 페이지 (피조회자 휴대폰 진입).
  // 로그인 불필요. 토큰 기반. 셜록 회원 헤더 hide.
  {
    path: "/sherlock/consent/:token",
    name: "sherlock-credit-consent",
    component: () => import("../views/sherlock/credit-default/ConsentExternalView.vue"),
    meta: { hideSherlockHeader: true },
  },

  // NZSC-3059 셜록 체납∙연체 — 동의 외부 페이지 "상세항목 보기" 라우트 (피그마 11609-16657).
  // 로그인 불필요. 토큰 기반. 뒤로 가기 시 동의 페이지로 복귀. 셜록 회원 헤더 hide.
  {
    path: "/sherlock/consent/:token/detail",
    name: "sherlock-credit-consent-detail",
    component: () => import("../views/sherlock/credit-default/ConsentExternalDetailView.vue"),
    meta: { hideSherlockHeader: true },
  },

  // NZSC-3074 셜록 체납∙연체 — KCB 본인인증 콜백 페이지.
  // lambda RETURN_URL: https://jasanoneclick.com/sherlock/credit/verify-result/{token}?mdl_tkn=...
  // 로그인 불필요. 토큰 + mdl_tkn 기반. 셜록 회원 헤더 hide.
  {
    path: "/sherlock/credit/verify-result/:token",
    name: "sherlock-credit-verify-result",
    component: () => import("../views/sherlock/credit-default/SherlockKcbVerifyResultView.vue"),
    meta: { hideSherlockHeader: true },
  },

  // NZSC-3074 셜록 체납∙연체 — KCB 개인 신용 조회 결과 (한 건 영구 접근).
  // BE: GET /v1/sherlock/credit/individual/result/:token  — used_date 무관 응답, 7일 만료(BE).
  // 로그인 불필요. 토큰 기반. 셜록 회원 헤더 hide (대상자 비로그인 페이지).
  {
    path: "/sherlock/credit/individual/result/:token",
    name: "sherlock-credit-individual-result",
    component: () => import("../views/sherlock/credit-default/SherlockKcbCreditResultView.vue"),
    meta: { hideSherlockHeader: true },
  },
];

export default sherlockRouter;
